var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMutedShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18064_219991)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18064_219991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.291 2.77488C14.291 2.16627 13.8446 1.66666 13.2196 1.66666C12.782 1.66666 12.4874 1.85742 12.0142 2.31161L8.34445 5.83613C8.29088 5.89064 8.23731 5.92697 8.1748 5.94514L7.80873 5.96331L14.291 12.5582V2.77488ZM17.1571 18.9623C17.4339 19.2348 17.8714 19.2348 18.1304 18.9623C18.3982 18.6807 18.4072 18.2446 18.1304 17.9721L2.84433 2.42061C2.57647 2.1481 2.13003 2.1481 1.86217 2.42061C1.60324 2.68405 1.60324 3.14732 1.86217 3.41075L17.1571 18.9623ZM5.17474 13.8299H7.83551C7.9248 13.8299 8.00516 13.8572 8.05873 13.9117L12.0142 17.736C12.4428 18.1447 12.7999 18.3264 13.2374 18.3264C13.6481 18.3264 13.9785 18.1084 14.1392 17.7905C14.1749 17.7087 14.2106 17.6179 14.2374 17.5179L3.68364 6.78085C3.38899 7.10787 3.2372 7.60748 3.2372 8.25243V11.7679C3.2372 13.1305 3.91578 13.8299 5.17474 13.8299Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18064_219991",
    x: 0.667969,
    y: 1.66666,
    width: 18.668,
    height: 19.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18064_219991"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18064_219991",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18064_219991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMutedShadow);
export default __webpack_public_path__ + "static/media/icon-muted-shadow.c5120ba6339edb5ef58d5135436cf173.svg";
export { ForwardRef as ReactComponent };